// extracted by mini-css-extract-plugin
export default {"btnpwd":"_351a9e5950"};